import { Directive, HostBinding, Input } from "@angular/core";

@Directive({
  selector: '[errorStateWithValidation]'
})
export class ErrorStateWithValidationDirective {
  @Input('hasFormError') hasFormError: boolean
  @Input('isInvalid') isInvalid: boolean

  @HostBinding('class.interval-required')
  get intervalRequiredClass() {
    if (!this.hasFormError) return true;
    return false
  }

  @HostBinding('class.interval-error')
  get intervalErrorClass() {
    if (this.hasFormError && this.isInvalid) return true;
    return false
  }

  @HostBinding('hidden')
  get hidden() {
    return this.isInvalid === false
  }
}